<template>
  <div>
       <app-header></app-header>
       <div id="particles"></div>
       <router-view></router-view>
  </div>
</template>

<script>
  import Header from './components/Header.vue';
  export default {
         components: {
             appHeader: Header
         },

          mounted(){
            particlesJS.load('particles','src/particles.json');
          }

       
     }

</script>

<style>
#particles{
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: white;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
}
</style>




// WEBPACK FOOTER //
// src/App.vue